/* src/app/views/doctor/doctor-detail/doctor-detail.component.css */
.border-blue-600 {
  border: 1px solid #0000ac;
}
.visit-type {
  position: relative;
  right: 22px;
  top: 83px;
}
input.visit-type:focus + label {
  color: #006ED3;
  background-color: #EBF5FF;
}
/*# sourceMappingURL=doctor-detail.component.css.map */
